import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import ErrorPage from "./ErrorPage";
import { globalErrorUIState } from "./globalErrorState";

export default function ErrorComponent() {
  const [open, setOpen] = useState(false);
  const errors = useRecoilValue(globalErrorUIState);

  useEffect(() => {
    setOpen(!!errors.length);
  }, [errors, setOpen]);

  return <>{open && <ErrorPage />}</>;
}
